module.exports = __webpack_public_path__ + "static/media/clone.19230f03.svg";